import React, { useState } from "react";
import "./ContactModal.css";

export default function ContactModal({ isOpen, onClose }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Remove the "data:image/jpeg;base64," prefix
        const base64String = reader.result.split(',')[1];
        resolve({
          data: base64String,
          extension: file.name.split('.').pop().toLowerCase()
        });
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleAddAttachment = (e) => {
    const files = Array.from(e.target.files);
    
    // Validate file types and sizes
    const validFiles = files.filter(file => {
      const isValidType = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type);
      const isValidSize = file.size <= 5 * 1024 * 1024; // 5MB limit
      return isValidType && isValidSize;
    });

    if (validFiles.length !== files.length) {
      alert("Some files were skipped. Please only upload images under 5MB.");
    }

    setAttachments(validFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !phone) {
      alert("Name and Phone are required.");
      return;
    }

    setIsSubmitting(true);

    try {
      // Convert all files to base64
      const base64Attachments = await Promise.all(
        attachments.map(convertFileToBase64)
      );

      const payload = {
        name,
        phone,
        email,
        location,
        description,
        attachments: base64Attachments
      };

      const response = await fetch("https://njaz3eadh6hzrlgozt6cnpj7ty0lbtni.lambda-url.us-east-1.on.aws/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const data = await response.json();
      
      alert("Form submitted successfully!");
      // Clear form
      setName("");
      setPhone("");
      setEmail("");
      setLocation("");
      setDescription("");
      setAttachments([]);
      onClose();
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("There was an issue submitting the form. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Contact Us for a Free Estimate</h2>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label>Name (Required):</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Phone (Required):</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Email (Optional):</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Location (Optional):</label>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Service Description (Optional):</label>
            <textarea
              rows="3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Attach Images (Optional, max 5MB each):</label>
            <input 
              type="file"
              multiple
              accept="image/*"
              onChange={handleAddAttachment}
            />
          </div>

          {attachments.length > 0 && (
            <div className="attachments-info">
              <p>{attachments.length} file(s) selected:</p>
              <ul>
                {attachments.map((file, idx) => (
                  <li key={idx}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}

          <button 
            type="submit" 
            className="submit-btn" 
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send"}
          </button>
        </form>

        <p className="contact-footer">
          Or contact us at <strong>540-985-1728</strong> <br />
          <strong>arelyconstructionandpainting@gmail.com</strong> (We speak English &amp; Spanish)
        </p>
      </div>
    </div>
  );
}
